// Components==============
import { useRedux } from 'hooks/useRedux';
import React, { createContext, useEffect, useMemo, useState } from 'react';
// =========================

type GlobalUploadImageModalContextType = {
  uploadImageModalIsOpen: boolean;
  setUploadImageModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalUploadImageModalContext = createContext(
  {} as GlobalUploadImageModalContextType
);

export default function GlobalUploadImageModal({
  children,
}: {
  children: React.ReactNode;
}) {
  const [uploadImageModalIsOpen, setUploadImageModalIsOpen] = useState(false);

  const userId = useRedux((state) => state?.authentication?.user?.id);

  const avatarUrl = useRedux(
    (state) => state?.authentication?.user?.avatar_url
  );

  useEffect(() => {
    if (!userId || (avatarUrl && avatarUrl?.length > 1)) return;
    setUploadImageModalIsOpen(true);
  }, [avatarUrl]);

  const value = useMemo(
    () => ({
      uploadImageModalIsOpen,
      setUploadImageModalIsOpen,
    }),
    [uploadImageModalIsOpen]
  );

  return (
    <GlobalUploadImageModalContext.Provider value={value}>
      {children}
    </GlobalUploadImageModalContext.Provider>
  );
}
